const isDevMode = process.env.NODE_ENV === 'development'

export default {
  isDevMode: isDevMode,
  pauseSignupPopup: isDevMode,
  localDatabase: false,
  useFakeData: false,
  globalShortcuts: isDevMode,
  logAdminUsers: false,
  devDatabase: false,
  enableBackupRestore: false
}
